import { render, staticRenderFns } from "./staffDepart.vue?vue&type=template&id=784581c7&scoped=true&"
import script from "./staffDepart.vue?vue&type=script&lang=js&"
export * from "./staffDepart.vue?vue&type=script&lang=js&"
import style0 from "./staffDepart.vue?vue&type=style&index=0&id=784581c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784581c7",
  null
  
)

export default component.exports